// Default configuration values for dropbox feature
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_CURRENT_PAGE = 1;

export const PAGE_SIZE_OPTIONS = [25, 50, 100, 250];

// File selection limits
export const MAX_FILES_LIMIT = 400;
export const MAX_SIZE_LIMIT_BYTES = 10 * 1024 * 1024 * 1024; // 10GB
